import { action, createStandardAction } from "typesafe-actions";

export enum actionTypes {
    SET_INITIAL_FILTERS = "SET_INITIAL_FILTERS",
    RESET_DEFAULT_FILTERS = "RESET_DEFAULT_FILTERS"
};

export const actions = {
    setInitialFilters: (payload: any) => action(actionTypes.SET_INITIAL_FILTERS, payload),
    resetDefaultFilters: createStandardAction(actionTypes.RESET_DEFAULT_FILTERS)()
};

export interface IJournalFilters {
    filters: {}
}

const initialState: IJournalFilters = {
    filters: {}
};

const reducer = (state = initialState, action: any): IJournalFilters => {
    const payload = action.payload;
    switch (action.type) {
        case (actionTypes.SET_INITIAL_FILTERS):
            return {
                ...state,
                filters: payload
            };
        case (actionTypes.RESET_DEFAULT_FILTERS):
            return {
                ...state,
                filters: {}
            };
        default:
            return state;
    }
};

export default reducer;